import { Entity } from '@hglobal/common';

export interface GeoLocation extends Entity {
  country: Country;
  city: string;
  region: string;
  street: string;
  house: string;
  apartment: string;
  zip: string;
}

export interface GeoLocationForApi {
  country: string;
  countryCode: string;
  city: string;
  region: string;
  street: string;
  houseNumber: string;
  apartment: string;
  postal: string;
}

export interface Country extends Entity {
  countryCode: string;
  countryName: string;
}

export function getLocationDataFromObj<T extends GeoLocationForApi>(obj: T): GeoLocationForApi {
  const { country, countryCode, city, region, street, houseNumber, apartment, postal } = obj;
  return {
    country,
    countryCode,
    city,
    region,
    street,
    houseNumber,
    apartment,
    postal,
  };
}

export function checkIsFullDefaultAddressDetected<T extends GeoLocationForApi>(obj: T): boolean {
  return !!(obj.country && obj.countryCode && obj.city && obj.region && obj.street && obj.houseNumber && obj.apartment && obj.postal);
}

export function checkIsAddressesTheSame(address1: GeoLocationForApi, address2: GeoLocationForApi): boolean {
  return (
    address1.country === address2.country &&
    address1.countryCode === address2.countryCode &&
    address1.city === address2.city &&
    address1.region === address2.region &&
    address1.street === address2.street &&
    address1.houseNumber === address2.houseNumber &&
    address1.apartment === address2.apartment &&
    address1.postal === address2.postal
  );
}
